import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flyer-page print-friendly" }
const _hoisted_2 = { class: "flyer-container" }
const _hoisted_3 = { class: "header-section" }
const _hoisted_4 = { class: "qr-section" }

import { onMounted, ref } from 'vue'
import QRCode from 'qrcode'


export default /*@__PURE__*/_defineComponent({
  __name: 'FlyerDropBoxView',
  setup(__props) {

const qrCodeCanvas = ref<HTMLCanvasElement | null>(null)

onMounted(async () => {
  if (qrCodeCanvas.value) {
    try {
      await QRCode.toCanvas(qrCodeCanvas.value, 'https://spacecoaststem.org', {
        width: 280,
        margin: 1,
        color: {
          dark: '#2c4a6b',
          light: '#ffffff'
        }
      })
    } catch (error) {
      console.error('Error generating QR code:', error)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Laptop Drop-Off Location", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo-section" }, [
          _createElementVNode("img", {
            src: "/assets/img/logo.png",
            alt: "Space Coast STEM Logo",
            class: "logo"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("canvas", {
            ref_key: "qrCodeCanvas",
            ref: qrCodeCanvas,
            class: "qr-canvas"
          }, null, 512)
        ])
      ]),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"info-section\" data-v-68f4f387><p class=\"info-text\" data-v-68f4f387> Space Coast STEM refurbishes donated laptops and gives them to <strong data-v-68f4f387>local students in Brevard County who need access to technology at home</strong>. </p><div class=\"accept-section\" data-v-68f4f387><h2 data-v-68f4f387>What We Accept</h2><div class=\"accept-grid\" data-v-68f4f387><div class=\"accept-item featured\" data-v-68f4f387><div class=\"featured-content\" data-v-68f4f387><div class=\"item-icon\" data-v-68f4f387>💻</div><div class=\"featured-text\" data-v-68f4f387><strong data-v-68f4f387>Laptops</strong><ul class=\"requirements\" data-v-68f4f387><li data-v-68f4f387>Working Screen &amp; Battery</li><li data-v-68f4f387>4GB RAM or More</li><li data-v-68f4f387>With or Without Hard Drive/SSD</li></ul></div></div></div><div class=\"accept-item\" data-v-68f4f387><div class=\"item-icon\" data-v-68f4f387>🔌</div><strong data-v-68f4f387>Power Adapters</strong></div><div class=\"accept-item\" data-v-68f4f387><div class=\"item-icon\" data-v-68f4f387>🎒</div><strong data-v-68f4f387>Laptop Bags/Backpacks</strong></div><div class=\"accept-item\" data-v-68f4f387><div class=\"item-icon\" data-v-68f4f387>🖱️</div><strong data-v-68f4f387>Computer Mice</strong></div></div></div></div><div class=\"contact-box\" data-v-68f4f387><p data-v-68f4f387>Questions or box full? Email <strong data-v-68f4f387>donations@spacecoaststem.org</strong></p></div>", 2))
    ])
  ]))
}
}

})